module.exports = __webpack_public_path__ + "img/logo.26e1e55f.jpg";